import { render } from "./ConfirmFileList.vue?vue&type=template&id=48bacc6d&scoped=true&ts=true"
import script from "./ConfirmFileList.vue?vue&type=script&lang=ts"
export * from "./ConfirmFileList.vue?vue&type=script&lang=ts"

import "./ConfirmFileList.vue?vue&type=style&index=0&id=48bacc6d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bacc6d"]])

export default __exports__